<template>
  <div class="page height-full">
    <app-header title="Profile"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <b-card no-body v-if="user != null">
      <div class="row ">
        <div class="col-md-12">
          <profile-form
            :user="user"
            :fields="fields"
            v-if="user != null"
          />
        </div>
      </div>      
    </b-card>
    <div class="card ">
      <div class="card-body p-0 white slimScroll" data-height="500">
        <div class="row ">
          <div class="col-md-2">
          </div>
          <div class="col-md-8">
            <div>
            </div>

            <div>
            </div>
          </div>
          <div class="col-md-2">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style>
  .nav {
    background-color: rgba(0, 0, 0, 0.03);
  }
</style>
<script>
  import { Auth } from 'aws-amplify'
  import Spinner from './common/Spinner'
  export default {
    name: 'Profile',
    components: {
      Spinner
    },
    data: () => {
      const that = this;
      return {
        mfa: false,
        fields: [
          {type: 'string', name: 'given_name', label: 'First Name'},
          {type: 'string', name: 'family_name', label: "Last Name"},
          {type: 'string', name: 'email', label: 'Email'},
          {type: 'string', name: 'phone_number', label: 'Phone Number'},
        ],
        user: null,
        isLoading: false
      };
    },
    methods: {
      toggleAccordion: function (el) {
        this[el] = !this[el]
      },
      getUser() {
        Auth.currentAuthenticatedUser()
          .then(user => {
            console.log(user)
            this.user = user
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      }
    },
    computed: {
      mfaConfig: function () {
        let that = this;
        return {
          mfaDescription: 'My app\'s mfa description!!',
          mfaTypes: ['TOTP', 'SMS', 'None'],
          cancelHandler: function () {
            that.toggleAccordion('mfa')
          },
        }
      },
      mfaAccordion: function () {
        return {
          'is-closed': !this.mfa,
          'is-primary': this.mfa,
          'is-dark': !this.mfa
        };
      }
    },
    mounted() {
      this.getUser()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue